<template>
    <div class="flex flex-col gap-4">
        <div v-if="props.title" class="text-xl font-extrabold">OAuth Client Credentials</div>
        <div>
            <vx-label size="lg">Token Endpoint</vx-label>
            <vx-input size="lg"
                :error="displayFirstError(validate.token_endpoint)"
                v-model="data.token_endpoint"></vx-input>
        </div>

        <div>
            <vx-label size="lg">Client ID</vx-label>
            <vx-input size="lg"
                :error="displayFirstError(validate.client_id)"
                v-model="data.client_id">
            </vx-input>
        </div>

        <div>
            <vx-label size="lg">Client Secret</vx-label>
            <vx-input size="lg"
                :error="displayFirstError(validate.client_secret)"
                v-model="data.client_secret"
                :placeholder="data.auth_config_id ? '•••••••••' : ''"
                :type="showSecret ? 'text' : 'password'"
                @focus="focusSecret"
                @blur="showSecret = false">
            </vx-input>
        </div>
    </div>
</template>

<script setup>
import { VxInput, VxLabel } from '@voxie/frontend-components';
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, required, url } from "@vuelidate/validators";
import { nextTick, ref } from 'vue';
import { useAuthConfigForm } from "~/components/settings/integrations/auth-configs/form/useAuthConfigForm";
import { displayFirstError } from "~/utils/validation";

const props = defineProps({
    title: {
        type: Boolean,
        default: false,
    }
});

const { data } = useAuthConfigForm();

const showSecret = ref(false);

const focusSecret = async () => {
    await nextTick();
    showSecret.value = true;
}

const rules = {
    token_endpoint: {
        required,
        maxLength: maxLength(2048),
        url,
        startsWith: helpers.withMessage(
            'Token Endpoint should start with \'https://\'.',
            (value) => value?.startsWith('https://') || false,
        ),
    },
    client_id: {
        required,
        maxLength: maxLength(100),
        regex: helpers.withMessage(
            'Client ID is invalid.',
            helpers.regex(/^[!-~]+$/),
        ),
    },
    client_secret: {
        required,
        maxLength: maxLength(255),
        regex: helpers.withMessage(
            'Client Secret is invalid.',
            helpers.regex(/^[!-~]+$/),
        ),
    },
};

const validate = useVuelidate(rules, data);
</script>
